import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['No need to count calories or follow restrictive diets.', 'Learn quick and easy food swaps that calm bloating fast.', 'A simple grocery list with anti-inflammatory staples you can find anywhere.', 'A 14-day "mix-and-match" meal template—no complicated recipes.', 'Daily 5-10 minute "belly-calm" habits to support your reset.', 'A realistic troubleshooting guide for those "off" days.', 'Feel lighter and see a difference in your waistline by the end of 14 days.'];
  return <section className="py-20 bg-white" data-id="element-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-ink" data-id="element-13">
            What You'll Get
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-14">
            Everything you need to calm your belly, simplified.
          </p>
        </div>

        <div className="bg-cream-light rounded-3xl p-8 md:p-12 shadow-sm border border-cream-dark" data-id="element-15">
          <ul className="space-y-6" data-id="element-16">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-17">
                <CheckCircleIcon className="h-6 w-6 text-sage-dark flex-shrink-0 mt-1 mr-4" aria-hidden="true" data-id="element-18" />
                <span className="text-lg text-ink leading-relaxed" data-id="element-19">
                  {benefit}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}